import { Component, OnInit, ViewChildren, QueryList, Input, Output, EventEmitter, ElementRef, ViewChild, OnDestroy, TemplateRef } from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import Swal from 'sweetalert2';
import { SharedService } from 'src/app/core/services/shared.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-documentos',
  templateUrl: './documentos.component.html',
  styleUrls: ['./documentos.component.scss']
})
export class DocumentosComponent implements OnInit {

  strWsdocumentos: string = "api/ws/hlp/hlp23arc/VerDocumentos/1";
  data: Array<string> = [];
  @Input() WsLlaves: Array<any> = [];
  tableData: Array<any>;
  ColumnasSN = [];



  constructor(private dataService: SharedService,
    private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    var jsonFiltros = this.toJSON("", this.WsLlaves);
    this.dataService.ConsultarWS(this.strWsdocumentos, JSON.stringify(jsonFiltros)).subscribe(
      (datosResp: any) => {
        this.data = datosResp.DATA;
        this.ColumnasSN = datosResp.DATA[0].TITULOS;
        this.tableData = datosResp.DATA[0].DATA_TABLE
      });
  }

  toJSON(operacion: string, arr: any[], url?: string, extra?: string) {
    return JSON.parse(
      '{ "LLAVES"   :' +
      JSON.stringify(arr) +
      (url != null ? ', "URL"      :"' + url + '"' : "") +
      (extra != null ? "," + extra : "") +
      ', "OPERACION":"' +
      operacion +
      '"}'
    );
  }

  dataURItoBlob(dataURI, strFORMATO?) {
    let strType = "application/octet-stream";
    if (strFORMATO == "XLS") strType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: strType });
    return blob;
  }

  parametros(parametros) {
    this.dataService.ConsultarWS("api/ws/hlp/hlp20arc/Descargar_adjuntos", JSON.stringify(parametros)).subscribe(
      (datosResp: any) => {
        const blob = this.dataURItoBlob(datosResp.base64);
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = datosResp.nombre;
        downloadLink.click();
      },
      error => {
        Swal.fire({
          title: 'Error',
          text: error,
          icon: 'error',
        })
      }
    );

  }


}
